import { useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'
import {
  IconLayoutDashboard, IconChartBar, IconBuildingSkyscraper,
  IconArrowLeft, IconMoon, IconSun, IconEyeCheck
} from '@tabler/icons-react'

const DRILL_IN_NAV = [
  { path: '/corporate/hotel-view', label: 'Dashboard', icon: IconLayoutDashboard, end: true },
  { path: '/corporate/hotel-view/reports', label: 'Reports', icon: IconChartBar },
  { path: '/corporate/hotel-view/group-resume', label: 'Group Resume', icon: IconBuildingSkyscraper },
]

export default function CorporateHotelView() {
  const { user, drillInHotel, exitHotel } = useAuth()
  const { dark, toggle } = useTheme()
  const navigate = useNavigate()

  const handleBack = () => {
    exitHotel()
    navigate('/corporate')
  }

  if (!drillInHotel) {
    navigate('/corporate')
    return null
  }

  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      <aside className="navbar navbar-vertical navbar-expand-lg" data-bs-theme="dark" style={{ width: 260, flexShrink: 0 }}>
        <div className="container-fluid d-flex flex-column h-100">
          <h1 className="navbar-brand navbar-brand-autodark mb-0">
            <span className="d-flex align-items-center gap-2">
              <IconBuildingSkyscraper size={28} />
              <span>
                <strong>Leadiox</strong>
                <small className="d-block text-secondary" style={{ fontSize: '0.7rem', marginTop: -2 }}>Hotel View</small>
              </span>
            </span>
          </h1>

          <div className="px-3 mb-2">
            <button className="btn btn-outline-light w-100 btn-sm d-flex align-items-center gap-2" onClick={handleBack}>
              <IconArrowLeft size={16} /> Back to Portfolio
            </button>
          </div>

          <div className="px-3 mb-3">
            <div className="card bg-dark border-secondary">
              <div className="card-body py-2 px-3">
                <div className="fw-medium text-white" style={{ fontSize: '0.9rem' }}>{drillInHotel.name}</div>
                <div className="text-secondary" style={{ fontSize: '0.75rem' }}>{drillInHotel.city}, {drillInHotel.state}</div>
              </div>
            </div>
          </div>

          <div className="px-3 mb-2">
            <button className="btn btn-dark w-100 btn-sm d-flex align-items-center gap-2" onClick={toggle}>
              {dark ? <IconSun size={16} /> : <IconMoon size={16} />}
              {dark ? 'Light Mode' : 'Dark Mode'}
            </button>
          </div>

          <div className="flex-grow-1">
            <ul className="navbar-nav pt-lg-3">
              {DRILL_IN_NAV.map(item => (
                <li key={item.path} className="nav-item">
                  <NavLink to={item.path} end={item.end} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <span className="nav-link-icon"><item.icon size={18} /></span>
                    <span className="nav-link-title">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-auto px-3 py-3 border-top border-secondary">
            <div className="d-flex align-items-center gap-2 text-warning" style={{ fontSize: '0.8rem' }}>
              <IconEyeCheck size={16} />
              <span>Viewing as {user?.role?.replace(/_/g, ' ')}</span>
            </div>
          </div>
        </div>
      </aside>

      <main className="flex-grow-1 p-4" style={{ overflowY: 'auto', maxHeight: '100vh' }}>
        {/* Read-only banner */}
        <div className="alert alert-warning d-flex align-items-center gap-2 mb-4">
          <IconEyeCheck size={18} />
          <span>You are viewing <strong>{drillInHotel.name}</strong> in read-only mode as <strong>{user?.role?.replace(/_/g, ' ')}</strong></span>
        </div>
        <Outlet />
      </main>
    </div>
  )
}
